<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon"><i class="pi pi-book"></i></div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة كورس جديد</h1>
        <p class="form-page-header__subtitle">أضف كورساً جديداً وحدد أسعاره وإعدادات ظهوره</p>
      </div>
    </div>
    <CourseForm />
  </div>
</template>

<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import CourseForm from './CourseForm.vue';

export default {
  name: 'CourseCreate',
  components: { Breadcrumb, CourseForm },
  data() {
    return {
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'الكورسات', path: '/courses' },
        { name: 'إضافة كورس', path: '/courses/create' },
      ],
    };
  },
};
</script>
